import { useEffect, useState } from "react";
import { IVehicle, PartsStatusDropdowns, PartsStatusValues } from "../../models/Vehicle";
import DashboardTile from "../dashboard/DashboardTile";
import { ILead } from "../../models/Lead";
import useVehicleStats from "../../data/useVehicleStats";
import { setEngine } from "crypto";
import { DateTime } from "luxon";
import useVehicleAwaitingStats from "../../data/useVehicleAwaitingStats";

interface IVehicleStatsProps {
  hasLeads?: boolean;

  filtersClickable?: boolean;
  setClickedFilter?: any;

  filters?: any;
  pageName?: string;

}

export default function VehicleAwaitingStats({ filtersClickable, setClickedFilter, filters, pageName, hasLeads }: IVehicleStatsProps) {
  const { stats } = useVehicleAwaitingStats(filters, pageName);

  const [engineExportCounts, setEngineExportCounts] = useState<any[]>([]);
  const [arrivingToday, setArrivingToday] = useState<number>(0);
  const [arrivingTomorrow, setArrivingTomorrow] = useState<number>(0);
  const [collectedToday, setCollectedToday] = useState<number>(0);
  const [awaitingCollection, setAwaitingCollection] = useState<number>(0);
  const [dropOff, setDropOff] = useState<number>(0);
  const [starts, setStarts] = useState<number>(0);

  const [selectedFilter, setSelectedFilter] = useState<number | undefined>(undefined);

  const hoverstyles = filtersClickable
    ? "hover:scale-[102%] hover:opacity-100 opacity-50 transition-all cursor-pointer"
    : "";

  const disabledStyles = hasLeads ? "" : "opacity-30 !pointer-events-none";

  const handleFilterClick = (index: number, filter: any) => {
    if (index === selectedFilter) {
      setSelectedFilter(undefined);
      setClickedFilter(undefined);
    } else {
      setSelectedFilter(index);
      setClickedFilter(filter);
    }
  };

  const partsStatus = [
    ...Object.values(PartsStatusDropdowns).filter((ct) => isNaN(Number(ct))),
  ];

  useEffect(() => {
    if (stats.isLoading || !stats.data) return;

    var data = stats.data.data;

    setEngineExportCounts(data.engineExportCounts);
    setCollectedToday(data.collectedToday);
    setAwaitingCollection(data.awaitingCollection);
    setDropOff(data.awaitingDropOff);
    setStarts(data.startsAndDrives);
    setArrivingToday(data.arrivingToday);
    setArrivingTomorrow(data.arrivingTomorrow);
  }, [stats.isLoading, stats.data]);

  return (
    <div className="bg-white shadow rounded p-4 mt-4 grid gap-4 grid-cols-1 grid-rows-1 sm:grid-rows-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4">

      <div className="row-span-2 h-full rounded bg-teal-100 text-teal-600 p-2 px-4 prose-base">
        <h1 className="mb-1 font-semibold">Parts Status</h1>
        <ul className="p-0 text-sm">
          {partsStatus.map((status, i) => (
            //@ts-ignore
            <li key={i} className="!m-0">
              {status}:{" "}
              {
                engineExportCounts?.find(
                  (count) =>
                    count.status ===
                    //@ts-ignore
                    PartsStatusValues[status]
                )?.count
              }
            </li>
          ))}
        </ul>
      </div>

      <div className={`h-full rounded bg-blue-100 text-blue-600 p-2 px-4 prose-base ${hoverstyles} ${disabledStyles} ${selectedFilter === 0 ? '!opacity-100 scale-[102%]' : ''}`}
        onClick={() => filtersClickable && handleFilterClick(0, { startDate: DateTime.now().toJSDate(), endDate: DateTime.now().toJSDate(), isCollected: false })}>
        <h1 className="text-blue-600 font-semibold">{arrivingToday}</h1>
        <p className="!m-0">Arriving Today</p>
      </div>

      <div className={`h-full rounded bg-pink-100 text-pink-600 p-2 px-4 prose-base ${hoverstyles} ${disabledStyles} ${selectedFilter === 1 ? '!opacity-100 scale-[102%]' : ''}`}
        onClick={() => filtersClickable && handleFilterClick(1, { startDate: DateTime.now().plus({ days: 1 }).toJSDate(), endDate: DateTime.now().plus({ days: 1 }).toJSDate(), isCollected: false })}>
        <h1 className="text-pink-600 font-semibold">{arrivingTomorrow}</h1>
        <p className="!m-0">Arriving Tomorrow</p>
      </div>

      <div className={`h-full rounded bg-green-100 text-green-600 p-2 px-4 prose-base ${hoverstyles} ${disabledStyles} ${selectedFilter === 2 ? '!opacity-100 scale-[102%]' : ''}`}
        onClick={() => filtersClickable && handleFilterClick(2, { collectedOn: DateTime.now().toJSDate() })}>
        <h1 className="text-green-600 font-semibold">{collectedToday}</h1>
        <p className="!m-0">Collected Today</p>
      </div>


      <div className={`h-full rounded bg-amber-100 text-amber-600 p-2 px-4 prose-base ${hoverstyles} ${disabledStyles} ${selectedFilter === 3 ? '!opacity-100 scale-[102%]' : ''}`}
        onClick={() => filtersClickable && handleFilterClick(3, { isScheduled: true, isCollected: false })}>
        <h1 className="text-amber-600 font-semibold">
          {awaitingCollection}
        </h1>
        <p className="!m-0">Awaiting Collection</p>
      </div>

      <div className={`h-full rounded bg-purple-100 text-purple-600 p-2 px-4 prose-base ${hoverstyles} ${disabledStyles} ${selectedFilter === 4 ? '!opacity-100 scale-[102%]' : ''}`}
        onClick={() => filtersClickable && handleFilterClick(4, { vehicleStarting: true })}>
        <h1 className="text-purple-600 font-semibold">{starts}</h1>
        <p className="!m-0">Starts & Drives</p>
      </div>

      <div className={`h-full rounded bg-rose-100 text-rose-600 p-2 px-4 prose-base ${hoverstyles} ${disabledStyles} ${selectedFilter === 5 ? '!opacity-100 scale-[102%]' : ''}`}
        onClick={() => filtersClickable && handleFilterClick(5, { isDropOff: true })}>
        <h1 className="text-rose-600 font-semibold">{dropOff}</h1>
        <p className="!m-0">Awaiting Drop Off</p>
      </div>

    </div>
  );
}